const initialCommon = {
    companies: [],
    designations : [],
    paymentmodes : [],
    accountyears : [],
    allcustomers : [],
    uoms : []
};

const CommonReducer = (common = initialCommon, action) => {
    switch (action.type) {
        case 'GET_COMPANY':
        return {
            ...common, companies: action.payload.data
        };
        case 'GET_DESIGNATION':
        return {
            ...common, designations: action.payload.data
        };
        case 'GET_PaymentMode':
        return {
            ...common, paymentmodes: action.payload.data
        };
        case 'GET_Accountyear':
        return {
            ...common, accountyears: action.payload.data
        };
        case 'GET_ALL_CUSTOMER':
        return {
            ...common, allcustomers: action.payload.data
        };
        case 'GET_ALL_UOM':
        return {
            ...common, uoms: action.payload.data
        };
        
        
        default:
            return common;
    }
}
export default CommonReducer;